export default "__VITE_ASSET__b_Pf4Y_R__"